import React, {Component} from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

import TabFilters from './TabFilters.js';
import SelectedFilters from '../selected-filters/SelectedFilters.js';
import SimpleSearchResultsList from './SimpleSearchResultsList.js';

//img
import arrow from '../../assets/icons/arrow-circle-empty-light.svg';

class SimpleSearchResultsTabContent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pageNum: props.page <= props.totalPages ? props.page : props.totalPages,
            updateList: false,
            isFilters: !props.isMobile,
        };
    };

    componentDidUpdate(prevProps, prevState) {
        const { updateResultsListParams, name, isMobile, isFieldsOpen } = this.props;
        const { ipp, pageNum, sorting, isFilters } = this.state;

        if (this.state.updateList) {
            this.setState({updateList: false});

            const isResetPage = prevState.sorting !== sorting || prevState.ipp !== ipp;

            updateResultsListParams(
                name,
                ipp,
                sorting,
                isResetPage ? 1 : pageNum,
            );
        }

        if (isFilters !== prevState.isFilters) {
            isFieldsOpen(isFilters && isMobile);
        }

        if (prevProps.isMobile !== isMobile) {
            this.setState({isFilters: !isMobile});
        }
    };

    // *****PAGE NAVIGATION*****

    setNextPage = () => {
        const {page, totalPages} = this.props;

        if (page < totalPages) {
            this.setState({pageNum: page + 1, updateList: true});
        }
    };

    setPreviousPage = () => {
        const {page} = this.props;

        if (page > 1) {
            this.setState({pageNum: page - 1, updateList: true});
        }
    };

    setCurrentPage = (event) => {
        const {totalPages} = this.props;
        const newVal = event.target.value;

        if ((newVal <= totalPages && newVal >= 1) || newVal === '') {
            this.setState({pageNum: newVal !== '' ? parseInt(newVal, 10) : newVal, updateList: false});
        }
    };

    setPageByNum = (num) => {
        const {page} = this.props;

        if (page !== num) {
            this.setState({pageNum: num, updateList: true});
        }
    };

    resetPageOnBlur = (event) => {
        const {totalPages, page} = this.props;
        const newVal = event.target.value;

        if (newVal === '' || newVal > totalPages || newVal < 1 || parseInt(newVal, 10) === page) {
            this.setState({pageNum: page, updateList: false});
        } else {
            this.setState({pageNum: parseInt(newVal, 10), updateList: true});
        }
    };

    setIpp = (val) => {
        const {perPage} = this.props;

        if (perPage !== val) {
            this.setState({ ipp: val, updateList: true });
        }
    };

    setSortOption = (option) => {
        const {sorting} = this.props;

        if (option && option.value !== sorting) {
            this.setState({ sorting: option.value, updateList: true });
        }
    };

    // ***** FILTERS *****

    setOpenedFilter = (id) => {
        this.setState({openedFilter: id});
    };

    toggleFilters = () => {
        this.setState({isFilters: !this.state.isFilters});
    };

    render() {
        const {name, allowedFilters, appliedFilters, results, ipp, isMobile,
              perPage, sorting, allowedSorting, totalPages, page,
              setFilter, loadFilterByName, loadAllFiltersByName, cleanAllFilters, removeFilter, applyFilter, expandTree,
              setIsBlocked, isFieldsOpen, clang, isBlocked, isHeadingsDetails, isLoggedIn, isAdvancedSearchResults} = this.props;

        const { isFilters, pageNum, openedFilter } = this.state;

        const newAppliedFilters = appliedFilters.filter(filter => !(isHeadingsDetails && (filter.id === 'HEADINGS' || filter.type === "SELECT")));
        const newAllowedFilters = allowedFilters ? allowedFilters.filter(filter => !(isHeadingsDetails && filter.name === 'HEADINGS') && ((isLoggedIn && !filter.visible) || filter.visible) && filter.type !== 'COMMON_ID') : false;

        const appliedFiltersActive = newAppliedFilters.filter(filter => filter.tab === name && filter.tab !== 'common' && filter.value && filter.value.length > 0);

        return (
            <div>
                {!isFilters &&
                    <div className={`results__tab-filters__toggle-container`}>
                        <button className="results__tab-filters__toggle" onClick={() => this.toggleFilters()}>
                           {lang[clang].results.choose_filters}
                           <img src={arrow} alt="" className="results__tab-filters__toggle-img"/>
                        </button>
                    </div>}

                {isFilters && !isAdvancedSearchResults &&
                    <TabFilters
                        allowedFilters={newAllowedFilters}
                        isHeadingsDetails={isHeadingsDetails}
                        expandTree={expandTree}
                        applyFilter={applyFilter}
                        appliedFilters={appliedFiltersActive}
                        setFilter={setFilter}
                        loadFilterByName={loadFilterByName}
                        loadAllFiltersByName={loadAllFiltersByName}
                        openedFilter={openedFilter}
                        isFilters={isFilters}
                        isMobile={isMobile}
                        toggleFilters={this.toggleFilters}
                        selectedFilters={appliedFiltersActive}
                        setOpenedFilter={this.setOpenedFilter}/>}

                {appliedFiltersActive.length > 0 && !isAdvancedSearchResults &&
                    <SelectedFilters
                        newData={appliedFiltersActive}
                        rememberOption={!isHeadingsDetails}
                        setIsBlocked={setIsBlocked}
                        isBlocked={isBlocked}
                        removeFilter={removeFilter}
                        cleanAllFilters={cleanAllFilters}/>}

                <SimpleSearchResultsList
                    results={results}
                    currentPageState={pageNum}
                    ipp={ipp}
                    perPage={perPage}
                    allowedSorting={allowedSorting}
                    totalPages={totalPages}
                    sorting={sorting}
                    page={page}
                    setSortOption={this.setSortOption}
                    setIpp={this.setIpp}
                    setCurrentPage={this.setCurrentPage}
                    resetPageOnBlur={this.resetPageOnBlur}
                    setPageByNum={this.setPageByNum}
                    setNextPage={this.setNextPage}
                    setPreviousPage={this.setPreviousPage}
                    isMobile={isMobile}
                    isFieldsOpen={isFieldsOpen}/>
            </div>
        );
    }
};

SimpleSearchResultsTabContent.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(SimpleSearchResultsTabContent);



// WEBPACK FOOTER //
// ./src/components/simple-search-results/SimpleSearchResultsTabContent.js